import PageHero from "@/components/jf/PageHero";
import Reveal from "@/components/jf/Reveal";
import Manifesto from "@/components/jf/Manifesto";
import Journey from "@/components/jf/Journey";
import Founder from "@/components/jf/Founder";

const PILLARS = [
  {
    k: "Vision",
    text: "A home in every story — to see Jaipur's handcrafted furniture treasured in the finest residences, hotels, cafés and workplaces across India and beyond.",
  },
  {
    k: "Mission",
    text: "To create timeless furniture that celebrates craftsmanship, reflects individuality, and delivers lasting value — one client, one piece, one home at a time.",
  },
];

export default function StoryPage() {
  return (
    <main>
      <PageHero
        kicker="Our Story"
        title={<>Built on patience, <em className="text-brass-soft font-light">kept by trust.</em></>}
        accent="13"
      >
        <p className="mt-8 max-w-xl text-ivory/70 font-light leading-relaxed text-base md:text-lg">
          From one woman's journey beginning in 2000 to one of Jaipur's most trusted furniture
          houses — this is how Jaipur Furniture came to be.
        </p>
      </PageHero>

      <section data-testid="vision-mission" className="bg-ivory py-24 md:py-32">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12 grid md:grid-cols-2 gap-6">
          {PILLARS.map((p, i) => (
            <Reveal key={p.k} delay={i * 0.08}>
              <div
                data-testid={`story-${p.k.toLowerCase()}`}
                className="border border-oxblood/20 hover:border-brass/70 transition-colors duration-500 p-10 md:p-14 h-full"
              >
                <span className="text-oxblood text-xs tracking-[0.45em] uppercase">{p.k}</span>
                <p className="mt-8 font-display text-oxblood-ink text-2xl md:text-3xl leading-snug font-light">
                  {p.text}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <Manifesto />
      <Journey />
      <Founder />
    </main>
  );
}
